module.exports = __webpack_public_path__ + "img/tech_image_11_2.85ea62a9.jpg";